module.exports = __webpack_public_path__ + "img/icon_more.949e5728.png";